const path = location.pathname;
const modalContent = new Vue({
  data: () => {
    return {
      productData: {},
      optionList: [],
      currentIndex: 0,
      mySwiper: null,
      freeShipTab: true,
      variantImg: "",
      showVariantSelect: false,
      option1: "",
      variantIndex: 0,
      freeStr: "Free",
      btnDisabled: false,
      wishStr: "wishList",
      customQuantity: 0,
      selectedValue1: "",
      selectedValue2: "",
      addCartTips: "Please add the products",
    };
  },

  mounted() {
    this.handleData();
    if (this.showFreeShipFlag) {
      this.filterFreeShip();
    } else {
      this.freeShipTab = false;
      if (this.productData.options) {
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue;
        this.option1 = this.optionList[0]?.value;
      }
    }
    this.mySwiper = new Swiper(".modal-product-slider", {
      slidesPerView: 5.1,
      spaceBetween: 20,
      slidesOffsetAfter: 10,
      // rtl: true, // 设置为从右到左轮播
      direction: "horizontal",
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    });
  },
  computed: {
    // 当前大图
    currentImage() {
      if (this.variantImg != "") return this.variantImg;
      if (!this.productData?.images || this.productData.images.length == 0)
        return "";
      return this.productData?.images[this.currentIndex];
    },
    // 格式化价格
    formatPrice() {
      if (this.productData?.maxPrice == this.productData?.minPrice) {
        return `${theme.formatPrice(
          theme.convertCurrency(this.productData?.maxPrice, "usdToSet")
        )}`;
      } else {
        return `${theme.formatPrice(
          theme.convertCurrency(this.productData?.minPrice, "usdToSet")
        )} - ${theme.formatPrice(
          theme.convertCurrency(this.productData?.maxPrice, "usdToSet"),
          false
        )}`;
      }
    },
    // 显示免邮tab
    showFreeShipFlag() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return false;
      for (let item of this.productData?.variants) {
        if (item.title.indexOf(this.freeStr) !== -1) {
          return true;
        }
      }
      return false;
    },
    totalItem() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return 0;
      let total = 0;
      for (let item of this.productData?.variants) {
        total += parseInt(item.quantity);
      }
      return total;
    },
    totalPrice() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return 0;
      let total = 0;
      for (let item of this.productData?.variants) {
        const price = theme.convertCurrency(item.price, "usdToSet");
        const totalPrice = theme.multiply(parseInt(item.quantity), price);
        total = theme.add(total, totalPrice);
      }
      return total;
    },
    isCustom() {
      if (
        this.productData?.customizeText == true ||
        this.productData?.customizeImage == true
      ) {
        return true;
      }
      return false;
    },
  },

  methods: {
    // 处理数据增加key
    async handleData() {
      var wishString = localStorage.getItem("wishList");
      var wishData = theme.inspectJson(wishString) || [];
      if (wishData.includes(this.productData.id)) {
        this.$set(this.productData, "favorite", true);
      } else {
        this.$set(this.productData, "favorite", false);
      }
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      for (let item of this.productData?.variants) {
        let isFreeShip = false;
        if (this.showFreeShipFlag) {
          isFreeShip =
            (item.freeShipping && item.title.indexOf(this.freeStr) != -1) ??
            false;
        } else {
          isFreeShip = item.freeShipping;
        }

        this.$set(item, "quantity", 0);
      }
    },

    // 处理图片地址
    handleImg(img, width) {
      if (!img) return "";
      if (img.indexOf("width=") == -1 && img.indexOf("?") == -1) {
        if (img.indexOf("?") != -1) {
          return `${img}&width=${width}`;
        }
        return `${img}?width=${width}`;
      }
      return img;
    },
    // 处理变体名称显示(去掉Free)
    handleVariantName(name) {
      if (!name) return "";
      if (name.indexOf(this.freeStr) != -1) {
        return name.split(this.freeStr)[1];
      }
      return name;
    },
    // 处理多变体时title显示（只显示最后一个）
    handleTitle(title) {
      if (!title) return "";
      if (title.indexOf("/")) {
        const arr = title.split("/");
        return arr[arr.length - 1];
      }
      return this.handleVariantName(title);
    },
    // 点击产品缩略图
    selectThumbnail(index) {
      this.variantImg = "";
      this.currentIndex = index;
    },

    clickSwiperPre() {
      this.mySwiper.slidePrev();
    },
    clickSwiperNext() {
      this.mySwiper.slideNext();
    },
    // 过滤免邮变体
    filterFreeShip() {
      this.freeShipTab = true;
      document.querySelector(".variants-list").scrollTop = 0;
      for (let item of this.productData.variants) {
        if (item.title.indexOf(this.freeStr) != -1) {
          this.$set(item, "freeTabFlag", true);
        } else {
          this.$set(item, "noFreeTabFlag", false);
        }
      }
      if (this.productData.options) {
        this.optionList = [];
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue.filter(
          (item) => item.value.indexOf(this.freeStr) != -1
        );
        this.option1 = this.optionList[0]?.value;
        this.variantIndex = 0;
      }
    },
    // 过滤非免邮变体
    filterNoFreeShip() {
      this.freeShipTab = false;
      document.querySelector(".variants-list").scrollTop = 0;
      for (let item of this.productData.variants) {
        if (item.title.indexOf(this.freeStr) == -1) {
          this.$set(item, "noFreeTabFlag", true);
        } else {
          this.$set(item, "freeTabFlag", false);
        }
      }
      if (this.productData.options) {
        this.optionList = [];
        const firstKey = Object.keys(this.productData.options)[0];
        const firstValue = this.productData.options[firstKey];
        this.optionList = firstValue.filter(
          (item) => item.value.indexOf(this.freeStr) == -1
        );
        this.option1 = this.optionList[0]?.value;
        this.variantIndex = 0;
      }
    },
    // 切换变体选项
    selectOption(option, index) {
      this.option1 = option.value;
      this.variantIndex = index;
      this.variantImg = option.img;
      this.currentIndex = -1;
      document.querySelector(".variants-list").scrollTop = 0;
    },
    // 单变体图片点击
    selectImg(img) {
      this.variantImg = img;
      this.currentIndex = -1;
    },
    // 变体列表数据是否显示
    filterVariantShow(variant) {
      // 双变体
      if (this.showVariantSelect) {
        const equal = variant?.options1?.value == this.option1;
        return (
          (!this.showFreeShipFlag ||
            variant.freeTabFlag ||
            variant.noFreeTabFlag) &&
          equal
        );
        // 其他
      } else {
        return (
          !this.showFreeShipFlag || variant.freeTabFlag || variant.noFreeTabFlag
        );
      }
    },
    // 更新选择的产品总数
    updateTotalCount() {
      for (let option of this.optionList) {
        let totalCount = 0;
        for (let item of this.productData.variants) {
          if (item.options1?.value == option.value) {
            totalCount += Number(item.quantity);
          }
        }
        option.count = totalCount;
      }
    },
    // 数量减少
    reduceQuantity(variant) {
      if (variant.quantity <= 0) return;
      const step = this.productData.minBatch || 1;

      // 按步长减少，确保不小于0
      const newQuantity = variant.quantity - step;
      variant.quantity = Math.max(0, newQuantity);
      this.updateTotalCount();
    },
    // 数量增加
    addQuantity(variant) {
      const step = this.productData.minBatch || 1;
      if (variant.quantity >= variant.inventoryQuantity) return;

      // 按步长增加，确保不超过库存
      const newQuantity = variant.quantity + step;
      variant.quantity = Math.min(variant.inventoryQuantity, newQuantity);
      this.updateTotalCount();
    },
    // 修改数量
    changeQuantity(variant) {
      const step = this.productData.minBatch || 1;
      let inputQuantity = parseInt(variant.quantity) || 0;

      if (inputQuantity <= 0) {
        variant.quantity = 0;
      } else {
        // 将输入的数量调整为最接近的步长倍数（向下取整）
        let adjustedQuantity = Math.floor(inputQuantity / step) * step;
        adjustedQuantity = adjustedQuantity == 0 ? step : adjustedQuantity;
        // 确保不超过库存限制
        variant.quantity = Math.min(
          adjustedQuantity,
          variant.inventoryQuantity
        );
      }
      this.updateTotalCount();
    },
    // 计算当前产品在购物车数据中的最小数量
    getMinQuantity() {
      let quantity = 0;
      if (cartPop) {
        cartPop.cartList.forEach((item) => {
          if (item.checked && item.product_id == this.productData.id) {
            quantity = theme.add(quantity, item.quantity);
          }
        });
      }
      return quantity;
    },
    // 加入购物车
    addToCart() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      const items = [];
      let totalQuantity = 0;
      const minQuantity = this.productData.minQuantity ?? 1;
      const minBatch = this.productData.minBatch ?? 1;
      for (let item of this.productData.variants) {
        if (item.quantity >= minBatch) {
          totalQuantity = theme.add(totalQuantity, item.quantity);
          items.push({
            quantity: item.quantity,
            id: item.id,
            variant_id: item.id,
            checked: true,

            url: this.productData.onlineStoreUrl,
            product_id: item.productId,
            product_title: this.productData.title,
            featured_image: { url: item.featureImage },
            variant_options: item.selectedOptions,
            final_price: item.price,
            weight: item.weight,
            min_batch: this.productData.minBatch,
            min_quantity: this.productData.minQuantity,
          });
        }
      }
      if (theme.add(totalQuantity, this.getMinQuantity()) < minQuantity) {
        if (minQuantity > 1)
          this.addCartTips = `Min. order: ${minQuantity} pieces`;
        this.btnDisabled = true;
        let timer = setTimeout(() => {
          this.btnDisabled = false;
          clearTimeout(timer);
        }, 1500);
      } else {
        this.btnDisabled = false;
      }
      if (!this.btnDisabled) {
        this.addToCartRequest(items);
      }
    },
    // 将变体数量重置
    resetQuantity() {
      if (!this.productData?.variants || this.productData.variants.length == 0)
        return;
      for (let item of this.productData.variants) {
        item.quantity = 0;
      }
      this.updateTotalCount();
    },
    // 加购请求 ()
    async addToCartRequest(cartItems) {
      const loading = document.querySelector(".loading-overlay__spinner");
      const message = document.getElementById("promptMessage"); //添加成功
      const masking = document.getElementById("masking"); //蒙版
      masking.classList.add("maskingShow");
      loading.classList.remove("hidden");
      const adapter = new StorageAdapter();
      const shopify = new ShopifyRelatedV2();
      const localKey = "cartItems";
      const items = await adapter.create({
        key: localKey,
        value: cartItems,
      });
      if (items) {
        this.resetQuantity();
        const quickAddModal = document.querySelector("quick-add-modal");
        if (quickAddModal) {
          quickAddModal.hide(true);
        }
        message.classList.remove("hidden");
        masking.classList.remove("hidden");
        loading.classList.add("hidden");
        message.classList.add("show");
        masking.classList.remove("maskingShow");
        var timer = setTimeout(() => {
          clearTimeout(timer);
          message.classList.remove("show");
          message.classList.add("hidden");
          masking.classList.add("hidden");
        }, 2000);
        if (cartPop) {
          cartPop.cartList = items;
          cartPop.shopifyCartData = await shopify.create(items);
          theme.reportAddToCart(cartItems);
          cartPop.handleDataList();
        }
      }
    },
    // 收藏或取消收藏
    async updateWish() {
      const productApi = new ProductAdapter();
      this.productData.favorite = !this.productData.favorite;
      if (this.productData.favorite) {
        productApi.addWish(this.productData);
      } else {
        productApi.cancelWish(this.productData);
      }
    },
    personalize() {
      var newWindow = window.open("", "_blank", "width=800,height=600");
      // 判断新窗口是否成功打开
      if (newWindow) {
        // 在新打开的窗口中设置跳转的网址
        newWindow.location.href = window.whatsappUrl;
      }
    },
  },
  template: `
    <div class="modal-content flex justify-space-between">
      <div class="left-content image-preview-container">
        <div class="relative">
          <div class="main-image">
            <img :src="handleImg(currentImage, 800)" :alt="productData.title">
          </div>
        </div>
        
        <div class="thumbnails relative">
          <div class="thumbnail-content modal-product-slider">
            <div class="swiper-wrapper">
              <div class="swiper-slide relative" :class="index == currentIndex ? 'active': '' " v-for="(item, index) in productData.images" @click="selectThumbnail(index)" @mouseenter="selectThumbnail(index)">
                <div class="main-image">
                  <img :src="handleImg(item, 140)" loading="lazy">
                </div>
              </div>
            </div>
          </div>
          <div class="nav-btn nav-btn-pre" @click="clickSwiperPre">
            <img class="arrow-left" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
          <div class="nav-btn nav-btn-next"  @click="clickSwiperNext">
            <img class="arrow-right" src="https://assets.gooddiy.com/image/arrow_up.png">
          </div>
        </div>
      </div>
      <div class="right-content">
        <h2 class="product-title">{{ productData.title }}</h2>
        <div class="free-ship flex align-items-center" v-if="productData.freeShipping">
          <img src="//www.gooddiy.com/cdn/shop/t/81/assets/freeShipping.png">
          <span>Free shipping over <span class="notranslate">{{ theme.formatPrice(
            theme.convertCurrency(98, "usdToSet", true)
          ) }}</span></span>
        </div>
        <div class="sku" v-if="productData.id">Item no: {{ productData.id }}</div>
        
        <div class="price notranslate text-active">{{ formatPrice }}</div>

        <div class="sku" v-if="productData.minQuantity>1">Min. order: <span class="font-bold">{{ productData.minQuantity }}</span> pieces</div>

        <div class="flex" v-if="showFreeShipFlag">
          <div class="product-tab" :class="freeShipTab ? 'active': ''" @click="filterFreeShip">freeshipping</div>
          <div class="product-tab" :class="!freeShipTab ? 'active': ''" @click="filterNoFreeShip">non-freeshipping</div>
        </div>
        <div v-if="showVariantSelect" class="multi-variant">
          <div v-for="(value, key, index) in productData.options">
            <div>
              <span class="title">{{ key}}</span> <span v-if="index==0">: <span class="text-active">{{ handleVariantName(option1) }}</span></span>
            </div>
            <div class="flex image-list" v-if="index==0">
              <div class="relative variant-img cursor-pointer" :class="variantIndex == index ? 'active' : ''" v-for="(option, index) in optionList" @click="selectOption(option, index)">
                <div class="main-image">
                  <img :src="handleImg(option.img, 800)" :alt="productData.title">
                </div>
                <div class="variant-count" v-if="option.count>0">{{ option.count }}</div>
              </div>
            </div>
          
            <div class="variants-list" v-else>
              <div class="variants-item" v-for="variant in productData.variants" v-show="filterVariantShow(variant)">
                <div class="flex justify-space-around align-items-center">
                  <div>
                    <div class="variant-title line-clamp-4">{{ handleTitle(variant.title) }}</div>
                  </div>
                  <div class="variant-price">
                    <div>{{ theme.formatPrice(theme.convertCurrency(variant.price , "usdToSet")) }}</div>
                    <div class="flex justify-content-center" v-if="freeShipTab || variant.freeShipping"><div class="free-ship-tag">free shipping</div></div>
                  </div>
                  <div>
                    <quantity-input class="quantity quantity-allff" :class="btnDisabled && variant.quantity <= 0 ? 'quantity-active': ''" v-if="!isCustom">
                      <button name="minus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity <= 0 ? 'disabled' : ''"  @click="reduceQuantity(variant)">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                        </svg>
                      </button> 
                      <input type="number" name="quantity" v-model="variant.quantity" @change="changeQuantity(variant)"class="quantity__input"> 
                      <button name="plus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity >= variant.inventory_quantity ? 'disabled' : ''" @click="addQuantity(variant)">
                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>
                      </button>
                    </quantity-input>
                    <div class="text-active sku center" v-if="productData.minBatch > 1">Min.Order is {{ productData.minBatch }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="variants-list" v-else>
          <div class="variants-item" v-for="variant in productData.variants" v-show="filterVariantShow(variant)">
            <div class="flex justify-space-between align-items-center">
              <div class="relative variant-img" @click="selectImg(variant.featureImage)">
                <div class="main-image cursor-pointer">
                  <img :src="handleImg(variant.featureImage, 500)" :alt="productData.title">
                </div>
              </div>
              <div>
                <div class="variant-title line-clamp-4">{{ handleVariantName(variant.title) }}</div>
                <div class="flex justify-content-center" v-if="freeShipTab || variant.freeShipping"><div class="free-ship-tag">free shipping</div></div>
              </div>
              <div class="variant-price notranslate">
                {{ theme.formatPrice(theme.convertCurrency(variant.price, "usdToSet")) }}
              </div>
              <div>
                <quantity-input class="quantity quantity-allff" :class="btnDisabled && variant.quantity <= 0 ? 'quantity-active': ''" v-if="!isCustom">
                  <button name="minus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity <= 0 ? 'disabled' : ''"  @click="reduceQuantity(variant)">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 2" class="icon icon-minus">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                    </svg>
                  </button> 
                  <input type="number" name="quantity" v-model="variant.quantity" @change="changeQuantity(variant)"class="quantity__input"> 
                  <button name="plus" type="button" class="quantity__button no-js-hidden" :class="variant.quantity >= variant.inventory_quantity ? 'disabled' : ''" @click="addQuantity(variant)">
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" viewBox="0 0 10 10" class="icon icon-plus">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>
                  </button>
                </quantity-input>
                <div class="text-active sku center" v-if="productData.minBatch > 1">Min.Order is {{ productData.minBatch }}</div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="flex">
          <div>
            <div class="text-active" v-if="btnDisabled">{{ addCartTips }}</div>
            <div v-if="!isCustom" class="add-to-cart-btn cursor-pointer" @click="addToCart">Add to Cart</div>
            <div v-else class="add-to-cart-btn cursor-pointer" @click="personalize">Personalize</div>
          </div>
          
          <div class="btn wishlist heratPop flex align-items-center cursor-pointer" @click="updateWish">
            <i class="at at-heart" v-if="productData.favorite"></i>
            <img class="no-wish" v-if="!productData.favorite" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png?v=93766581999082064381724318209" alt="">
          </div>
        </div>
        <div class="total-count flex justify-space-between" v-if="!isCustom">
          <div>Total <span class="text-active notranslate">{{ totalItem || 0 }}</span> Items</div>
          <div class="text-active notranslate">{{ theme.formatPrice(totalPrice || 0) }}</div>
        </div>
      </div>
    </div>`,
});
if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector("#QuickAddInfo");
        this.closeDom = this.querySelector("#ModalClose");
        this.productUrl = "web.ProductService/Product";
        this.productId = "";
      }

      hide(preventFocus = false) {
        this.querySelector(".variants-list")
          ? (this.querySelector(".variants-list").scrollTop = 0)
          : "";
        modalContent.productData = {};
        modalContent.currentIndex = 0;
        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      async show(opener) {
        // if (this.isMobile) {

        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        this.productId = opener.getAttribute("data-product-id");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.remove("hidden");
        await this.getData();
        modalContent.$mount("#QuickAddInfo");
        super.show(opener);
        this.closeDom.classList.add("multi-close-btn");
        opener.removeAttribute("aria-disabled");
        opener.classList.remove("loading");
        opener
          .querySelector(".loading-overlay__spinner")
          .classList.add("hidden");
      }
      async getData() {
        const product = new ProductApi();
        const productData = await product.getProductData(this.productId);
        if (productData) {
          modalContent.variantImg = "";
          modalContent.currentIndex = 0;
          modalContent.productData = productData;
          modalContent.showVariantSelect = false;
          modalContent.productData = this.handleData(productData);
          if (
            modalContent.productData?.variants[0]?.selectedOptions.length == 2
          ) {
            modalContent.showVariantSelect = Object.values(
              modalContent.productData?.options
            ).every((arr) => arr.length > 2);
          }
        }
      }

      handleData(originalData) {
        // 深拷贝原始数据
        const newData = { ...originalData };
        const selectedOptions = originalData?.variants[0]?.selectedOptions;
        // 构建新的 options 对象
        const options = {};
        for (let item of selectedOptions) {
          options[item.name] = [];
        }

        // 为每个 variant 添加 option1 和 option2
        const newVariants = originalData.variants.map((variant) => {
          const newOptions = {};
          let count = 0;
          for (let option in options) {
            ++count;
            const optionValue = variant.selectedOptions.find(
              (opt) => opt.name == option
            );
            newOptions[`options${count}`] = optionValue;
          }
          return {
            ...variant,
            ...newOptions,
          };
        });

        // 从 variants 中提取选项值和对应的图片
        originalData.variants.forEach((variant) => {
          variant.selectedOptions.forEach((option) => {
            const optionKey = option.name;
            // 检查该值是否已经存在
            const existingOption = options[optionKey].find(
              (item) => item.value === option.value
            );
            if (!existingOption) {
              options[optionKey].push({
                value: option.value,
                img: variant.featureImage, // 使用该 variant 的特征图片
                count: 0,
              });
            }
          });
        });
        // 构建最终的数据结构
        return {
          ...newData,
          options,
          variants: newVariants,
        };
      }

      // setInnerHTML(element, html) {
      //   element.innerHTML = html;

      //   // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      //   element.querySelectorAll("script").forEach((oldScriptTag) => {
      //     const newScriptTag = document.createElement("script");
      //     Array.from(oldScriptTag.attributes).forEach((attribute) => {
      //       newScriptTag.setAttribute(attribute.name, attribute.value);
      //     });
      //     newScriptTag.appendChild(
      //       document.createTextNode(oldScriptTag.innerHTML)
      //     );
      //     oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      //   });
      // }

      // renderMobileHTML(data, sectionId) {
      //   const variantSize = data.variants.length;
      //   const price = this.getPrice(data.variants);
      //   const featured_id = data.variants[0].id;
      //   const attrList = this.displayAttrs(data, sectionId);
      //   const str = `<div class="mobile-quick-add">
      //   <div class="m-model-header flex relative align-center">
      //     <div class="attr-img-content">
      //       <img
      //         class="attr-img"
      //         src="${data.featured_image}"
      //         alt=""
      //       >
      //     </div>
      //     <h2 class="wb_proleft_head ">
      //       ${variantSize} styles to choose from
      //     </h2>
      //   </div>
      //   <div class="card_product_Price">
      //     <span class="card_sale_price">
      //       ${price}
      //     </span>
      //   </div>
      //   <div class="m-product-popup-modal__content-info">
      //     <div class="">
      //       ${attrList}
      //     </div>
      //   </div>
      //   <div class="opens-add-cart">
      //     <div class="to-wish">
      //       <div
      //         class="btn wishlist heratPop addto-wishlist"
      //         data-id="${data.id}"
      //         rel="${data.handle}"
      //       >
      //         <i class="at at-heart"></i>
      //         <img class="no-wish" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png?v=93766581999082064381719987185" alt="">
      //       </div>
      //     </div>
      //     <div class="bottom-buy-btn">
      //       <div class="flex align-center">
      //         <product-form class="product-form" data-hide-errors="false">
      //           <div class="product-form__error-message-wrapper" role="alert" hidden="">
      //             <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
      //               <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
      //               <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
      //               <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
      //               <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
      //             </svg>
      //             <span class="product-form__error-message"></span>
      //           </div>
      //           <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" id="product-form-${sectionId}-${data.id}" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
      //             <input type="hidden" name="form_type" value="product">
      //             <input type="hidden" name="utf8" value="✓">
      //             <input type="hidden" name="id" value="${featured_id}" class="product-variant-id">
      //             <div class="product-form__buttons">
      //               <div class="pro_qtyside disabled">
      //                 <button id="ProductSubmitButton-${sectionId}" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog">
      //                   <span>Add to cart</span>
      //                   <div class="loading-overlay__spinner hidden">
      //                     <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      //                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      //                     </svg>
      //                   </div>
      //                 </button>
      //               </div>
      //             </div>
      //             <input type="hidden" name="product-id" value="${data.id}">
      //             <input type="hidden" name="section-id" value="${sectionId}">
      //           </form>
      //         </product-form>
      //       </div>
      //     </div>
      //   </div>
      // </div>`;
      //   this.modalContent.innerHTML = str;
      // }

      // preventVariantURLSwitching() {
      //   const variantPicker = this.modalContent.querySelector(
      //     "variant-radios,variant-selects"
      //   );
      //   if (!variantPicker) return;

      //   variantPicker.setAttribute("data-update-url", "false");
      // }

      // removeDOMElements() {
      //   const pickupAvailability = this.productElement.querySelector(
      //     "pickup-availability"
      //   );
      //   if (pickupAvailability) pickupAvailability.remove();

      //   const productModal = this.productElement.querySelector("product-modal");
      //   if (productModal) productModal.remove();

      //   const modalDialog =
      //     this.productElement.querySelectorAll("modal-dialog");
      //   if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      // }

      // preventDuplicatedIDs() {
      //   const sectionId = this.productElement.dataset.section;
      //   this.productElement.innerHTML =
      //     this.productElement.innerHTML.replaceAll(
      //       sectionId,
      //       `quickadd-${sectionId}`
      //     );
      //   this.productElement
      //     .querySelectorAll("variant-selects, variant-radios, product-info")
      //     .forEach((element) => {
      //       element.dataset.originalSection = sectionId;
      //     });
      // }

      // removeGalleryListSemantic() {
      //   const galleryList = this.modalContent.querySelector(
      //     '[id^="Slider-Gallery"]'
      //   );
      //   if (!galleryList) return;

      //   galleryList.setAttribute("role", "presentation");
      //   galleryList
      //     .querySelectorAll('[id^="Slide-"]')
      //     .forEach((li) => li.setAttribute("role", "presentation"));
      // }

      // updateImageSizes() {
      //   const productEle = this.modalContent.querySelector(".product");
      //   const desktopColumns =
      //     productEle.classList.contains("product--columns");
      //   if (!desktopColumns) return;

      //   const mediaImages = productEle.querySelectorAll(".product__media img");
      //   if (!mediaImages.length) return;

      //   let mediaImageSizes =
      //     "(min-width: 1000px) 715px, (min-width: 768px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

      //   if (productEle.classList.contains("product--medium")) {
      //     mediaImageSizes = mediaImageSizes.replace("715px", "605px");
      //   } else if (productEle.classList.contains("product--small")) {
      //     mediaImageSizes = mediaImageSizes.replace("715px", "495px");
      //   }

      //   mediaImages.forEach((img) =>
      //     img.setAttribute("sizes", mediaImageSizes)
      //   );
      // }

      // imgAddEvent() {
      //   const mutliDom = this.querySelector(".multi-var-header");
      //   if (this.isMobile && !mutliDom) {
      //     this.displayImg = this.querySelector(".attr-img");
      //     this.activeIndex = 0;
      //     this.querySelectorAll(".m-quantity-l").forEach((item, index) => {
      //       if (index == 0)
      //         item.querySelector(".varirimg").classList.add("active");
      //       item.addEventListener("click", () => {
      //         const imgEle = item.querySelector(".varirimg");
      //         const imgSrc = imgEle.querySelector("img").src;
      //         const preActive =
      //           this.querySelectorAll(".m-quantity-l")[
      //             this.activeIndex
      //           ].querySelector(".varirimg");
      //         this.displayImg.src = imgSrc;
      //         if (imgEle.classList.contains("active")) return false;
      //         imgEle.classList.add("active");
      //         preActive.classList.remove("active");
      //         this.activeIndex = index;
      //       });
      //     });
      //   } else {
      //     this.querySelectorAll(".variant-qu .varirimg").forEach((item) => {
      //       item.addEventListener("click", function (event) {
      //         event.stopPropagation();
      //         event.stopPropagation();
      //         const mediaGalleries = document.querySelector(
      //           `[id^="MediaGallery-${this.dataset.section}"]`
      //         );
      //         const sliderItems =
      //           mediaGalleries.querySelectorAll('[id^="Slide-"]');
      //         let src = this.querySelector("img").src;
      //         src = src.replace("width=100", "width=823");
      //         const srcset = `${src} 493w,${src} 600w,${src} 713w,${src} 823w,${src} 990w,${src} 1100w,${src} 1200w`;
      //         sliderItems[0].querySelector("img").src = src;
      //         sliderItems[0].querySelector("img").srcset = srcset;
      //         const thumSlider = document.querySelector(
      //           '[id^="GalleryThumbnails"]'
      //         );
      //         const thumSliderItems =
      //           thumSlider.querySelectorAll('[id^="Slide-"]');
      //         thumSliderItems.forEach((slider) => {
      //           slider
      //             .querySelector(".thumbnail")
      //             .removeAttribute("aria-current");
      //         });
      //       });
      //     });
      //   }
      // }

      // getIndexOfFirstNumber(str) {
      //   const match = str.match(/\d/);
      //   return match ? match.index : -1;
      // }
      // getIndexOfEndNumber(str) {
      //   for (let i = str.length - 1; i >= 0; i--) {
      //     if (/\d/.test(str[i])) {
      //       return i;
      //     }
      //   }
      //   return -1;
      // }

      // replaceStr(replaceStr, isHideCode) {
      //   const priceFormat = document
      //     .querySelector(".price-format")
      //     .textContent.trim();
      //   let strNew = "";
      //   if (priceFormat.indexOf("-") == -1) {
      //     strNew = priceFormat;
      //   } else {
      //     strNew = priceFormat.split("-")[1];
      //   }
      //   if (isHideCode) {
      //     const end = this.getIndexOfEndNumber(strNew);
      //     strNew = strNew.slice(0, end + 1);
      //   }
      //   const start = this.getIndexOfFirstNumber(strNew);
      //   const end = this.getIndexOfEndNumber(strNew);
      //   const oldStr = strNew.slice(start, end + 1);
      //   return strNew.replace(oldStr, replaceStr);
      // }

      // getPrice(variants) {
      //   let priceList = [];
      //   variants.forEach(function (item) {
      //     priceList.push(item.price / 100);
      //   });
      //   const minPrice = Math.min(...priceList);
      //   const maxPrice = Math.max(...priceList);
      //   if (minPrice != maxPrice) {
      //     return `<span class="price trans-money">${this.replaceStr(
      //       minPrice.toFixed(2),
      //       true
      //     )}</span> - <span class="price trans-money">${this.replaceStr(
      //       maxPrice.toFixed(2)
      //     )}</span>`;
      //   }
      //   return `<span class="price trans-money">${this.replaceStr(
      //     minPrice.toFixed(2),
      //     true
      //   )}</span>`;
      // }

      // displayAttrs(product, sectionId) {
      //   let str = "";
      //   product.variants.forEach((item) => {
      //     const img = item.featured_image ? item.featured_image.src : "";
      //     const productUrl = `products/${product.handle}`;
      //     const price = this.replaceStr((item.price / 100).toFixed(2), true);
      //     str += `
      //   <div class="flex align-center justify-space-between m-quantity-l attribute">
      //     <div class="varirimg">
      //       <img class="object-cover" alt="${product.title}" src="${img}?crop=center&amp;v=${item.id}&amp;width=100">
      //     </div>
      //     <div class="flex attribute-title">
      //       ${item.title}
      //     </div>
      //     <div>
      //       <span class="card_sale_price price"><span class="trans-money">${price}</span></span>
      //     </div>
      //     <quantity-input class="quantity quantity-allff" data-url="${productUrl}" data-section="${sectionId}">
      //       <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
      //         <span class="visually-hidden">${product.title}</span>
      //         <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
      //           <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
      //         </svg>
      //       </button>
      //       <input class="quantity__input" type="number" name="quantity" value="0" form="product-form-${sectionId}-${product.id}" data-product-id="${product.id}" min="0">
      //       <input type="hidden" name="id" data-name="${product.title}" class="varinantsinputid" value="${item.id}">
      //       <button class="quantity__button no-js-hidden" name="plus" type="button">
      //         <span class="visually-hidden">${product.title}</span>
      //         <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
      //           <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
      //         </svg>
      //       </button>
      //     </quantity-input>
      //   </div>`;
      //   });
      //   return str;
      // }

      // renderMultiVariation(product, sectionId) {
      //   const featured_id = product.variants[0].id;
      //   const attrFirst = this.displayAttrFirst(product.options[0]);
      //   const attrSecond = this.displayAttrSecond(
      //     product.options[1],
      //     product,
      //     sectionId
      //   );
      //   const price = this.getPrice(product.variants);
      //   this.multiAttrName = product.options[0]?.list[0]?.option1;
      //   const imgSrc = product.options[0]?.list[0]?.featured_image?.src;
      //   const str = `<div class="mobile-quick-add relative">
      //   <div class="m-model-header flex align-center multi-var-header">
      //     <img
      //       class="attr-img"
      //       src="${imgSrc}"
      //       alt=""
      //     >
      //     <h2 class="wb_proleft_head ">
      //       ${product.title}
      //     </h2>
      //   </div>
      //   <div class="multi-title content">
      //     Price: ${price}
      //   </div>
      //   ${attrFirst}
      //   ${attrSecond}
      //   <div class="opens-add-cart">
      //     <div class="to-wish">
      //       <div
      //         class="btn wishlist heratPop addto-wishlist"
      //         data-id="${product.id}"
      //         rel="${product.handle}"
      //       >
      //         <i class="at at-heart"></i>
      //         <img class="no-wish" src="//www.gooddiy.com/cdn/shop/t/82/assets/no_wish.png?v=93766581999082064381719987185" alt="">
      //       </div>
      //     </div>
      //     <div class="bottom-buy-btn">
      //       <div class="flex align-center">
      //         <product-form class="product-form" data-hide-errors="false">
      //           <div class="product-form__error-message-wrapper" role="alert" hidden="">
      //             <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
      //               <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
      //               <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
      //               <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path>
      //               <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path>
      //             </svg>
      //             <span class="product-form__error-message"></span>
      //           </div>
      //           <form method="post" action="/cart/add" accept-charset="UTF-8" class="form" id="product-form-${sectionId}-${product.id}" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
      //             <input type="hidden" name="form_type" value="product">
      //             <input type="hidden" name="utf8" value="✓">
      //             <input type="hidden" name="id" value="${featured_id}" class="product-variant-id">
      //             <div class="product-form__buttons">
      //               <div class="pro_qtyside disabled">
      //                 <button id="ProductSubmitButton-${sectionId}" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog">
      //                   <span>Add to cart</span>
      //                   <div class="loading-overlay__spinner hidden">
      //                     <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      //                       <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      //                     </svg>
      //                   </div>
      //                 </button>
      //               </div>
      //             </div>
      //             <input type="hidden" name="product-id" value="${product.id}">
      //             <input type="hidden" name="section-id" value="${sectionId}">
      //           </form>
      //         </product-form>
      //       </div>
      //     </div>
      //   </div>
      // </div>`;
      //   this.modalContent.innerHTML = str;
      //   this.attrAddClickEvent();
      //   this.showAttrList();
      // }

      // displayAttrFirst(data) {
      //   let str = ``;
      //   for (let item of data.list) {
      //     str += `
      //     <div class="first-attr">
      //       <div class="first-attr-item" data-src="${item.featured_image.src}" data-name="${item.option1}">
      //         <img src="${item.featured_image.src}">
      //         <div class="first-attr-name">${item.option1}</div>
      //         <div class="attr-count"><span>0</span></div>
      //       </div>
      //     </div>
      //   `;
      //   }
      //   return `<div class="content">
      //   <div class="multi-title">${data.name}: <span class="first-attr-title">${data.list[0].option1}</span></div>
      //   <div class="flex first-attr-list">${str}</div>
      // </div>
      // `;
      // }
      // displayAttrSecond(data, product, sectionId) {
      //   let str = ``;
      //   const productUrl = `products/${product.handle}`;
      //   for (let key in data.list) {
      //     const attrList = data.list[key];
      //     attrList.forEach((item) => {
      //       const price = this.replaceStr((item.price / 100).toFixed(2));
      //       str += `
      //       <div class="flex align-center justify-space-between m-quantity-l attribute" data-attr="${key}">
      //         <div class="flex attribute-title">
      //           ${item.option2}
      //         </div>
      //         <div>
      //           <span class="card_sale_price price"><span class="trans-money">${price}</span></span>
      //         </div>
      //         <quantity-input class="quantity quantity-allff" data-url="${productUrl}" data-section="${sectionId}">
      //           <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
      //             <span class="visually-hidden">${product.title}</span>
      //             <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
      //               <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
      //             </svg>
      //           </button>
      //           <input class="quantity__input" type="number" name="quantity" value="0" form="product-form-${sectionId}-${product.id}" data-product-id="${product.id}" min="0">
      //           <input type="hidden" name="id" data-name="${product.title}" class="varinantsinputid" value="${item.id}">
      //           <button class="quantity__button no-js-hidden" name="plus" type="button">
      //             <span class="visually-hidden">${product.title}</span>
      //             <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
      //               <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path>
      //             </svg>
      //           </button>
      //         </quantity-input>
      //       </div>`;
      //     });
      //   }
      //   return `<div class="content">
      //   <div class="multi-title">${data.name}: </div>
      //   <div class="second-attr-list">${str}</div>
      // </div>
      // `;
      // }

      // showAttrList() {
      //   const attrListDom = this.querySelectorAll(
      //     ".second-attr-list .attribute"
      //   );
      //   attrListDom.forEach((item) => {
      //     const attr = item.dataset.attr;
      //     if (attr == this.multiAttrName) {
      //       item.classList.remove("hidden");
      //     } else {
      //       item.classList.add("hidden");
      //     }
      //   });
      // }

      // attrAddClickEvent() {
      //   const listDom = this.querySelectorAll(".first-attr-item");
      //   const imgDom = this.querySelector(".multi-var-header .attr-img");
      //   const attrDom = this.querySelector(".first-attr-title");
      //   listDom[this.activeIndex].classList.add("active");
      //   listDom.forEach((item, index) => {
      //     item.addEventListener("click", () => {
      //       if (!item.classList.contains("active")) {
      //         const src = item.dataset.src;
      //         const attr = item.dataset.name;
      //         item.classList.add("active");
      //         listDom[this.activeIndex].classList.remove("active");
      //         this.activeIndex = index;
      //         imgDom.src = src;
      //         attrDom.innerText = attr;
      //         this.multiAttrName = attr;
      //         this.showAttrList();
      //       }
      //     });
      //   });
      // }
    }
  );
}
